import {
  useAppDispatch,
  useAppSelector,
} from "../redux-store/CustomReduxHooks";
import {
  useLazyFetchProfileDetailsQuery,
  useLazySaveCampaignDetailsQuery,
} from "../features/Feature_GeneralAppElements/GeneralAppElements_Api";
import { updateLoadingState } from "../features/Feature_Loading/Loading_Slice";
import {
  updateUserProfileDetails,
  updateUserProfilePanDetails,
} from "../redux-store/reducers/CsAppSlice";
import CsLocalStorageUtils from "../utils/CsLocalStorageUtils";
import { T_GetCustomerLobDetailsRes } from "../features/Feature_Login/Login_Types";
import CsSessionStorageUtils from "../utils/CsSessionStorageUtils";
import {
  E_ChannelOptions,
  T_CampaignHeaders,
} from "../globalTypes/GlobalTypes";
import { setError } from "../redux-store/reducers/CsErrorSlice";
import { isEmpty } from "lodash";
import cleverTap, { triggerCleverTapEvent } from "../utils/CleverTap";
import { onUserLoginCleverTapStatic, SCREEN_TYPE } from "../utils/constants";

const useProfileAndSaveCampaignApi = () => {
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const secondaryChannelSlice = useAppSelector(
    (state) => state.SecondaryChannelSlice
  );
  const mobileNumber = useAppSelector(
    (state) => state.LoginSlice.mobilenumber || ""
  );

  const dispatch = useAppDispatch();
  const [getProfileDetailApi] = useLazyFetchProfileDetailsQuery();
  const [saveCampaignDetailsApi] = useLazySaveCampaignDetailsQuery();

  const saveCampaignDetailsApiFun = async (data: any) => {
    const campaignIdentifiers: T_CampaignHeaders[] = JSON.parse(
      CsSessionStorageUtils.get("CAMPAIGN_IDENTIFIERS")
    );
    let Identifiers = campaignIdentifiers.reduce((acc: any, item) => {
      acc[item.key] = item.value;
      return acc;
    }, {});
    const ciiNumber =
      data.customerAndLobDetails.find(
        (item: any) =>
          item?.LOB && item?.PRIMARY_SECONDARY_USER === "primary" && item?.CII
      )?.CII || "";

    let reqPayload = {
      csUserId: data?.CS_USER_ID || "",
      traceId: csAppSlice.traceId || "",
      channel: csAppSlice.channel || "",
      source: csAppSlice.deviceType || "",
      utmSource: Identifiers.utm_source || "",
      utmId: Identifiers.utm_id || "",
      utmMedium: Identifiers.utm_medium || "",
      utmCampaign: Identifiers.utm_campaign || "",
      utmTerm: Identifiers.utm_term || "",
      utmContent: Identifiers.utm_content || "",
      utmAdId: Identifiers.utm_adid || "",
      utmAdgroup: Identifiers.utm_adgroup || "",
      ciiNo: ciiNumber,
      functionality: secondaryChannelSlice?.functionalityCode || "",
      mobileNo: secondaryChannelSlice?.mobileNo || "",
      lobClientId: data?.customerAndLobDetails?.[0].LOBID || "",
      lobId: data?.customerAndLobDetails?.[0]?.LOB_CODE,
      appVersion: "",
      panNumber:
        secondaryChannelSlice?.panNumber ||
        data?.customerAndLobDetails?.[0]?.PAN ||
        data?.pan,
      customerFullName: data?.name,
      customerDob: data?.dob,
      emailId: data?.emailId,
      osVersion: "Windows",
      imei: "",
      deviceId: "",
      userAgent: navigator.userAgent,
      clientIpAddress: "",
      udp: "",
      udp2: "",
      udp3: "",
      udp4: "",
      udp5: "",
    };
    await saveCampaignDetailsApi(reqPayload);
  };

  const profileDetailsApiFun = async (
    csLobDetails: T_GetCustomerLobDetailsRes
  ) => {
    // dispatch(updateLoadingState(true));
    await getProfileDetailApi({
      csUserId: csLobDetails.CS_USER_ID || "",
      mobile: "",
    }).then((res) => {
      //   dispatch(updateLoadingState(false));
      let onUserLoginCleverTapData = { ...onUserLoginCleverTapStatic };
      onUserLoginCleverTapData["MSG-push"] = !isEmpty(
        csAppSlice.NativeDeviceInfo?.deviceName
      );
      if (res.isSuccess) {
        let payload = {
          ...res.data?.payload?.[0],
          name: res.data?.payload?.[0]?.name?.replaceAll("?", "'"),
        };

        onUserLoginCleverTapData["Name"] = payload.name;
        onUserLoginCleverTapData["Identity"] = csAppSlice.csUserId;
        onUserLoginCleverTapData["Email"] = payload.emailId;
        onUserLoginCleverTapData["Phone"] = "+91" + payload.mobileNumber;
        onUserLoginCleverTapData["DOB"] = new Date(payload.dob);
        onUserLoginCleverTapData["MSG-email"] = !isEmpty(payload.emailId);
        onUserLoginCleverTapData["MSG-sms"] = !isEmpty(payload.mobileNumber);
        onUserLoginCleverTapData["MSG-whatsapp"] = !isEmpty(
          payload.mobileNumber
        );
        if (isEmpty(csAppSlice.NativeDeviceInfo?.deviceName)) {
          cleverTap.onUserLogin.push({ Site: onUserLoginCleverTapData });
        }
        dispatch(updateUserProfileDetails(payload));
        if (csAppSlice.channel === E_ChannelOptions.SECONDARY_CHANNEL) {
          saveCampaignDetailsApiFun({
            ...res.data?.payload?.[0],
            ...csLobDetails,
          });
        }
        if (res.data?.payload?.[0]) {
          CsLocalStorageUtils.set("MOBILE", res.data.payload?.[0].mobileNumber);
        }
      }
      if (res.isError || res.error) {
        onUserLoginCleverTapData["Identity"] = "+91" + mobileNumber;
        onUserLoginCleverTapData["Phone"] = "+91" + mobileNumber;
        if (isEmpty(csAppSlice.NativeDeviceInfo?.deviceName)) {
          cleverTap.onUserLogin.push({ Site: onUserLoginCleverTapData });
        }
        dispatch(updateUserProfilePanDetails({ pan: "" }));
        dispatch(setError({ error: res?.error as Error, message: "" }));
      }
      triggerCleverTapEvent("onUserLogin", {
        ScreenType: SCREEN_TYPE.DashboardScreenType,
        ScreenName: "Servicing Homescreen",
        isPrevPageNameRequired: true,
        ...onUserLoginCleverTapData,
        MSG_email: onUserLoginCleverTapData["MSG-email"],
        MSG_push: onUserLoginCleverTapData["MSG-push"],
        MSG_sms: onUserLoginCleverTapData["MSG-sms"],
        MSG_whatsapp: onUserLoginCleverTapData["MSG-whatsapp"],
      });
    });
  };
  return profileDetailsApiFun;
};

export default useProfileAndSaveCampaignApi;
